import { Button } from "antd";
import LineSpacer from "../../../components/LineSpacer";
import { PlusOutlined, EditFilled } from "@ant-design/icons";
import { RezerwaContext } from "../../../context/rezerwaContext";
import { useContext } from "react";
import numberFormat from "../../../components/numberFormat";
import { useAuth } from "../../../context/AuthContext";
import CancelButton from "./CancelButton";
import SaveButton from "./SaveButton";
import datetimeParser from "../../../components/datetimeParser";
import Transfer from "./Transfer";
import getWeekOfYearFromTimestamp from "../../../components/getWeekOfYear";
import { useState } from "react";
import isCan from "../../../components/isCan";
import { useEffect } from "react";

const TransferStage = (props) => {
	const { rezerwa, setrezerwa } = useContext(RezerwaContext);
	const isDisabled = rezerwa.mode === "preview";
	const { user } = useAuth();
	const total =
		parseFloat(rezerwa?.rezerwa_data?.data?.rezerwa?.msr_reserves_amount) ||
		0;
	const selectedPerson = rezerwa?.rezerwa_data?.data?.rezerwa;
	const [cando, setCando] = useState(false);
	const perms = user.perms;

	// Użycie useEffect do ustawiania wymaganych uprawnień
	useEffect(() => {
		const fetchPermissions = async () => {
			const result = await isCan(["can_edit_reserves"], perms);
			setCando(result);
		};
		fetchPermissions();
	}, [perms]);

	const handleAddTransfer = () => {
		const newTransfer = {
			msr_transfers_id: `temp_${Date.now()}`,
			msr_transfers_create_datetime: Math.floor(
				new Date().getTime() / 1000,
			),
			msr_transfers_own_id: Math.floor(new Date().getTime() / 1000),
			msr_transfers_amount:
				total -
					selectedPerson?.msr_transfers?.reduce(
						(sum, tr) => sum + parseFloat(tr.msr_transfers_amount),
						0,
					) || 0,
			msr_transfers_account_number: "",
			msr_transfers_account_owner: "",
			msr_transfers_title_suffix: "",
			msr_transfers_title: "",
			msr_transfers_description: "",
			msr_transfers_types_id:
				rezerwa?.rezerwa_data?.data?.default_values
					?.msr_transfers_types[0]?.msr_transfers_types_id || null,
		};

		setrezerwa((prev) => {
			const updatedTransfers = [
				...(prev.rezerwa_data?.data?.rezerwa?.msr_transfers || []),
				newTransfer,
			];

			const changes = [...(prev.changes || [])];
			changes.push({
				etap: "Przelewy",
				field: "msr_transfers",
				label: "Dodano przelew",
				action: "add",
				oldValue: null,
				newValue: `Dodano nowy przelew o ID ${newTransfer.msr_transfers_own_id}`,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: newTransfer.msr_transfers_own_id,
				personid: selectedPerson.msr_persons_own_id,
			});

			return {
				...prev,
				rezerwa_data: {
					...prev.rezerwa_data,
					data: {
						...prev.rezerwa_data?.data,
						rezerwa: {
							...prev.rezerwa_data?.data?.rezerwa,
							msr_transfers: updatedTransfers,
						},
					},
				},
				changes,
			};
		});
	};

	return (
		rezerwa && (
			<>
				<div
					style={{
						position: "sticky",
						top: 0,
						textAlign: "center",
						padding: "20px",
						marginBottom: "20px",
						display: "flex",
						background: "white",
						zIndex: 100,
						gap: "20px",
						width: "100%",
						alignItems: "center",
						justifyContent: "space-between",
						borderBottom: "1px solid rgba(0,0,0,0.2)",
						paddingBottom: "20px",
					}}
				>
					<div
						style={{
							display: "flex",
							gap: "20px",
							alignItems: "center",
						}}
					>
						{rezerwa.mode == "preview" ? (
							<div
								style={{
									padding: "10px 20px",
									background: "red",
									color: "white",
								}}
							>
								PODGLĄD
							</div>
						) : (
							""
						)}
						<div style={{ opacity: 0.5 }}>
							ID rezerwy: #
							{
								rezerwa?.rezerwa_data?.data?.rezerwa
									?.msr_reserves_own_id
							}
						</div>
						<div style={{ opacity: 0.5 }}>
							Data ostatniej zmiany rezerwy:{" "}
							{datetimeParser(
								rezerwa?.rezerwa_data?.data?.rezerwa
									?.msr_reserves_own_id,
								"YYYY-MM-DD",
							)}{" "}
							|{" "}
							{getWeekOfYearFromTimestamp(
								rezerwa?.rezerwa_data?.data?.rezerwa
									?.msr_reserves_own_id,
							)}{" "}
							tydzień
						</div>
					</div>

					<div
						style={{
							display: "flex",
							gap: "10px",
							alignItems: "center",
						}}
					>
						<CancelButton />
						{cando &&
							(rezerwa.mode === "preview" ? (
								<Button
									onClick={() =>
										setrezerwa({ ...rezerwa, mode: "edit" })
									}
									type="primary"
									icon={<EditFilled />}
								>
									Edytuj
								</Button>
							) : (
								<>
									<div
										style={{
											display: "flex",
											gap: "10px",
											padding: "10px 10px",
											background: "#f1f1f1",
											border: "1px solid black",
										}}
									>
										<Button
											onClick={() =>
												setrezerwa({
													...rezerwa,
													mode: "preview",
													reload: !rezerwa.reload,
												})
											}
										>
											Wyłącz edycje
										</Button>
										<SaveButton></SaveButton>
									</div>
								</>
							))}
					</div>
				</div>
				<div
					style={{
						padding: "20px",
						paddingTop: "0px",
					}}
				>
					<div
						style={{
							padding: "16px",
							borderRadius: "8px",
							background: "white",
							color: "black",
							border: "2px solid #BD8136",
							display: "grid",
							gridTemplateColumns: "repeat(4, 1fr)",
							gap: "20px",
						}}
					>
						<div>
							<div>ID osoby</div>
							<div
								style={{
									fontSize: "16px",
									marginTop: "8px",
									fontWeight: "700",
								}}
							>
								#
								{selectedPerson?.msr_persons_own_id ||
									"Brak danych"}
							</div>
						</div>
						<div>
							<div>Imię i nazwisko</div>
							<div
								style={{
									fontSize: "16px",
									marginTop: "8px",
									fontWeight: "700",
								}}
							>
								{selectedPerson?.msr_persons_name ||
									"Brak danych"}{" "}
								{selectedPerson?.msr_persons_lastname || ""}
							</div>
						</div>
						<div>
							<div>Kwota rezerwy do przelewu</div>
							<div
								style={{
									fontSize: "16px",
									marginTop: "8px",
									fontWeight: "700",
								}}
							>
								{numberFormat(total || 0)} zł
							</div>
						</div>
					</div>
					<div
						style={{
							display: "flex",
							gap: "20px",
							alignItems: "center",
							margin: "20px 0",
						}}
					>
						<div
							style={{
								background: "white",
								color: "black",
								padding: "7px 0",
								fontSize: "18px",
								borderRadius: "5px",
							}}
						>
							Przelewy
						</div>
						<LineSpacer />
						{!isDisabled && (
							<Button
								disabled={
									(selectedPerson?.msr_transfers?.reduce(
										(sum, tr) =>
											sum +
											parseFloat(tr.msr_transfers_amount),
										0,
									) || 0) == total
								}
								onClick={handleAddTransfer}
							>
								Dodaj wypłatę
							</Button>
						)}
					</div>
					{rezerwa.rezerwa_data?.data?.rezerwa?.msr_transfers?.map(
						(transfer, i) => (
							<Transfer
								total={total}
								key={transfer.msr_transfers_id}
								index={i}
								transfer={transfer}
								selectedPerson={selectedPerson}
							/>
						),
					)}
				</div>
			</>
		)
	);
};

export default TransferStage;
